import { partnerCentralSubBrands } from '../../constants/common';

const toId = (value) => {
    if (typeof value === 'number') {
        return Number.isFinite(value) && value !== -1 ? String(value) : null;
    }
    if (typeof value !== 'string' || value === '' || value === '-1') {
        return null;
    }
    return value;
};

class EgClickstreamEventTemplates {
    static instance;

    static addEpcDuaid() {
        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop)
        });
        if (params.epc_duaid) {
            return {
                trace_id_of_the_view: params.epc_duaid
            };
        }
        return {};
    }

    static getInstance() {
        if (!this.instance) {
            const {
                appName,
                brand,
                publicUuid,
                userType
            } = window.egClickstreamdatalayer;
            const brandCustomerId = brand === partnerCentralSubBrands.vrbo ? toId(publicUuid) : null;
            this.instance = {
                event: {
                    event_category: `tpg.${appName}`,
                    action_reason: userType
                },
                identifiers: {
                    ...this.addEpcDuaid()
                },
                experience: {
                    app_name: appName,
                    app_version: '1.0.0'
                },
                point_of_sale: {
                    eg_brand_name: 'Partner Central',
                    sub_brand_name: brand
                }
            };
            if (brandCustomerId) {
                this.instance.user = {
                    brand_customer_id: brandCustomerId
                };
            }
        }
        return this.instance;
    }

    static setPartnerTuid(userId) {
        if (!this.instance) this.getInstance();
        const partnerTuid = toId(userId);
        if (!partnerTuid) {
            return;
        }
        this.instance.partner_common = this.instance.partner_common ?? {};
        this.instance.partner_common.spx_partner_tuid = partnerTuid;
    }

    static setBrandCustomerId(publicUuid) {
        if (!this.instance) this.getInstance();
        if (this.instance.point_of_sale.sub_brand_name !== partnerCentralSubBrands.vrbo) {
            return;
        }
        const brandCustomerId = toId(publicUuid);
        if (!brandCustomerId) {
            return;
        }
        this.instance.user = this.instance.user ?? {};
        this.instance.user.brand_customer_id = brandCustomerId;
    }

    static createCustomEvent(customFields, event) {
        return {
            ...event,
            ...customFields
        };
    }

    static createEvent({ experience, event }) {
        const obj = this.getInstance();
        return {
            ...obj,
            experience: {
                ...obj.experience,
                ...experience
            },
            event: {
                ...obj.event,
                ...event
            }
        };
    }
}

export default EgClickstreamEventTemplates;
